const pluginCache = {};
export function extend(plg) {
    pluginCache[plg.name] = plg;
}
export function plugin(name) {
    return pluginCache[name] || window[name];
}
